module.exports = __webpack_public_path__ + "static/NotoSansKR-Black-25ab3626b77d039abe87a29ef5e78de9.otf";